import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import { slipCells } from './slip-cells';
import Cell from './Cell';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { addHorsetoBetSlip, removeHorseFromBetSlip } from 'Store/actions/horseRacing';
import { horseMapperForBetslip } from 'Utils/horseRacesNameMapper';
import { decimalFormatterLast } from 'Utils/decimalFormatter';
import { isBetslipValid, isBetSlipEmpty } from 'Utils/horseRacingBetslipValidation';
import { openModal } from 'Store/actions';
import {
  verifyTJKCoupon,
  setHRBetslipAllVariation,
  setHRBetslipCouponCount,
  setHRBetslipMultiplier,
  removeAllHorsesFromBetSlip,
  addAllHorsestoBetSlip,
  resetHRBetSlip,
  removeHorseFromCombinedBetSlip,
  setBetslipToast,
  resetBetSlipToast,
  addHorseToCombinedBetSlip,
  toggleSystemModal
} from 'Store/actions/horseRacing/betSlipActions';
import inputMinMaxValidatorHorseRacing from 'Utils/inputMinMaxValidatorHorseRacing';
import { saveTjkCoupon } from 'Store/actions/horseRacing/couponActions';
import { playTJKCoupon } from 'Store/actions/horseRacing';
import { setSelectedProgramLeg } from 'Store/actions/horseRacing/getRaceInfos';
import History from 'Store/history';
import ErrorMessage from './ErrorMessage';
import SelectedLegsList from './SelectedLegs';
import LottieLoader from 'Components/LottieLoader';
import { Checkbox } from 'Components/Form';
import { BOX_TYPES, CELL_TYPES } from './constants';
import { useMediaQuery } from 'react-responsive';
import MobileBetSlip from './MobileView';
import qs from 'query-string';
import { navigateWithParams, getSearchParams } from 'Utils/horseRacingRouteHelper';
import OrderList from './OrderList';
import { withMixpanel } from 'Utils/mixpanel';
import { RUNWAY_TYPES } from 'Utils/horseRacesNameMapper';
import PropTypes from 'prop-types';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { oddFormatter } from 'Utils/decimalFormatter';
import EnvironmentManager from 'Utils/environmentManager';
import ToastTemplate from 'Components/ToastTemplate';
import InfoPopup from '../../pages/HorseRacing/InfoPopup';
import { classnames } from 'Utils/classnames';
import Predicta from 'Components/Predicta';
import { useHRBetslipSystem } from 'Utils/hooks/useHRBetslipSystem';

const NewBetSlip = ({ mixpanel }) => {
  const isMobil = useMediaQuery({
    query: '(max-width: 768px)'
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const play = useSelector(state => state.horseRacing?.betSlip?.play);
  const { isAuthenticated } = useSelector(state => state.auth);
  const hippodromeBetDetails = useSelector(state => state.horseRacing.hippodromeBetDetails);
  const hippodromeInfo = useSelector(state => state.horseRacing.hippodromesInfo);
  const selectedHippodrome = hippodromeInfo?.data?.find(h => h.cardId ? h.cardId === hippodromeInfo.selectedHippodromeId : h.akey === hippodromeInfo.selectedHippodromeId);
  const availableBets = useSelector(state => state.horseRacing.hippodromeAvailableBets);
  const betSlip = useSelector(state => state.horseRacing.betSlip);
  const { legs, verify, selectedInfos, footerData, isLoadedFromCouponConfig, isOpen } = betSlip;
  const { allVariation, couponCount, multiplier, system, fixedOddMultiplier } = footerData;
  const verifyData = verify?.data?.body || {};
  const verifyErrorData = verify?.error?.extras || {};
  const pageLoading = hippodromeInfo?.isLoading || hippodromeBetDetails?.isLoading || availableBets?.isLoading;
  const selectedLegNo = hippodromeBetDetails.selectedProgramLeg.legNo;
  const fromAuthorData = useSelector(state => state?.horseRacing?.authorComments?.playedData);
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const infos = useSelector(state => state.horseRacing.hippodromeBetDetails.infos);
  const { combinedHorses } = betSlip;

  const maxHorseCount = Number(EnvironmentManager.getMessageText({ key: 'v1.general.parlay_odd_limit_count' })) || 4;
  const systemAllowed = verifyData?.systemAllowed || verifyErrorData?.systemAllowed;
  const isFixedOdd = programType === PROGRAM_TYPES.FIXED;

  const [selectedBet, setSelectedBet] = useState(null);
  const [cells, setCells] = useState(null);
  const [maxLegCount, setMaxLegCount] = useState(0);
  const [isLocaleValid, setIslocaleValid] = useState(false);
  const [cost, setCost] = useState('0 TL');
  const [state, setState] = useState({
    couponCount: couponCount || 1,
    multiplier: isFixedOdd ? fixedOddMultiplier : multiplier || 1,
  });
  const [legNumbers, setLegNumbers] = useState([]);
  const [arrowAnimating, setArrowAnimating] = useState(false);
  const [isBetWithComma, setIsBetWithComma] = useState(false);
  const [info, setInfo] = useState(null);
  const { systemSelected } = useHRBetslipSystem();


  const getData = (col, row) => {
    if (selectedBet?.boxType === BOX_TYPES.HORSE && col < selectedBet?.legSize) {
      return hippodromeBetDetails?.data?.legs[0]?.horseDetail?.find(horse => horse.horseNo === row - 1);
    }
    return hippodromeBetDetails?.data?.legs[col]?.horseDetail?.find(horse => horse.horseNo === row - 1);
  };
  const getLegNo = col => {
    if (selectedBet?.boxType === BOX_TYPES.HORSE) return col + 1;
    return Number(legNumbers[col]);
  };
  const getRunwayType = col => {
    if (selectedBet?.boxType === BOX_TYPES.HORSE) return hippodromeBetDetails?.data?.legs[0]?.runwayType || '';
    return hippodromeBetDetails?.data?.legs[col]?.runwayType || '';
  };
  const isAllSelected = (col, row) => {
    if (row === 1) {
      if (selectedBet?.boxType === BOX_TYPES.HORSE) {
        return hippodromeBetDetails?.data?.legs[0]?.horseDetail?.filter(e => e.isRunning)?.length === legs[col + 1]?.length;
      } else {
        const legNo = Number(legNumbers[col]);
        const currentLeg = hippodromeBetDetails?.data?.legs[col];
        return currentLeg?.horseDetail?.filter(e => e.isRunning)?.length === legs[legNo]?.length;
      }
    } else {
      return false;
    }
  };
  const handleLegSelect = (leg, data) => {
    const i = selectedBet?.boxType === BOX_TYPES.HORSE ? 0 : data?.colNo;
    const legData = hippodromeBetDetails?.data?.legs[i];
    legData.index = data?.colNo + 1;
    const query = getSearchParams();
    query.li = data?.colNo + 1;
    query.ln = leg;

    navigateWithParams({ type: 'replace', search: qs.stringify(query) });
    dispatch(setSelectedProgramLeg(legData));
  };
  const addLegToBetslip = (leg, data) => {
    if (legs[leg]?.some(item => item.horseNo === data.horseNo)) {
      dispatch(removeHorseFromBetSlip(leg, horseMapperForBetslip(data)));
    } else {
      dispatch(addHorsetoBetSlip(leg, horseMapperForBetslip(data), {
        selectedHippodrome,
        selectedBet,
        selectedRaceNumber: availableBets.selectedRaceNumber,
        legsData: hippodromeBetDetails?.data?.legs.map(e => ({
          ...e,
          horseDetail: null
        }))
      }));
    }
  };
  const addAllToBetslip = (leg, data) => {
    if (data?.isAllSelected) {
      dispatch(removeAllHorsesFromBetSlip(leg));
    } else {
      const index = selectedBet?.boxType === BOX_TYPES.HORSE ? 0 : data?.colNo;
      dispatch(addAllHorsestoBetSlip(leg,
        hippodromeBetDetails?.data?.legs[index]?.horseDetail?.filter(e => e.isRunning)?.map(horse => horseMapperForBetslip(horse)),
        {
          selectedHippodrome,
          selectedBet,
          selectedRaceNumber: availableBets.selectedRaceNumber,
          legsData: hippodromeBetDetails?.data?.legs.map(e => ({
            ...e,
            horseDetail: null
          }))
        }
      ));
    }
  };
  const onCellClick = (leg, data, type) => {
    switch (type) {
      case CELL_TYPES.HORSE:
        addLegToBetslip(leg, data);
        handleLegSelect(leg, data);
        break;
      case CELL_TYPES.ALL_SELECT_BUTTON:
        addAllToBetslip(leg, data);
        handleLegSelect(leg, data);
        break;
      case CELL_TYPES.LEG_NO:
        handleLegSelect(leg, data);
        break;
      default:
        break;
    }

  };
  const onChange = e => {
    const numberRegex = /^[0-9\b]+$/;
    const isValid = e.target.value !== '' ? numberRegex.test(e.target.value) : true;
    const { id, value } = e.target;

    if (isValid) {
      setState(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };
  const onBlur = e => {
    const { id, value } = e.target;

    if (value === '') {
      return;
    }

    const modifiedValue = inputMinMaxValidatorHorseRacing({
      id,
      value,
    }, isFixedOdd, systemSelected);

    setState(prev => ({
      ...prev,
      [id]: modifiedValue.value,
    }));

    if (id === 'multiplier') {
      dispatch(setHRBetslipMultiplier(modifiedValue.value));
    } else {
      dispatch(setHRBetslipCouponCount(modifiedValue.value));
    }

  };
  const onFocus = e => {
    e.target.value = '';
  };
  const onPlayClick = () => {
    const betDetail = legs.map((selectedLeg, index) => {
      if (selectedLeg) {
        return {
          'Coupon Race Number': selectedInfos?.legsData?.findIndex(item => item?.legNo === index) + 1,
          'Hipoddrome Race Number': index,
          'Track List': RUNWAY_TYPES[selectedInfos?.legsData?.find(item => item?.legNo === index)?.runwayType],
          'Horse Detail': selectedLeg.map(selectedHorse => {
            return {
              'Horse Kit Number': selectedHorse?.horseNo,
              'Horse Name': selectedHorse?.name,
              AGF: selectedHorse?.agf,
              'Jockey Name': selectedHorse?.tag?.jokeyDetail?.name,
              'Handicap Point': selectedHorse?.tag?.handicap,
              'Rest Days Count': selectedHorse?.tag?.kgs,
              Lane: selectedHorse?.tag?.boxNo,
              Age: selectedHorse?.tag?.age,
              'Weight (kg)': selectedHorse?.tag?.weight,
              'Last Races': selectedHorse?.tag?.lastRaceRanks,
              'Father Name': selectedHorse?.origin?.father?.name,
              'Mother Name': selectedHorse?.origin?.mother?.name,
              Jewelry: selectedHorse?.accessory,
              Stablemate: selectedHorse?.stablemateGroupInfo > 0,
              'Stablemate Name': selectedHorse?.stablemateGroupInfo > 0 ? selectedLeg?.find(item => item?.stablemateGroupInfo === selectedHorse?.stablemateGroupInfo && item.key !== selectedHorse?.key)?.name : null,
              Owner: selectedHorse?.ownership?.owner?.name,
              Trainer: selectedHorse?.ownership?.coach?.name,
              Breeder: selectedHorse?.ownership?.steward?.name,
              'Horse Key': selectedHorse?.key,
              Odd: selectedHorse?.probableGain,
            };
          })
        };
      }
    });
    const mixpanelEvents = {
      Hippodrome: selectedHippodrome?.city,
      'Bet Type': selectedBet?.description,
      'Bet Type Order Selection': selectedInfos?.selectedRaceNumber,
      'Bet Amount': multiplier,
      'Multiple Coupon Flag': couponCount > 1,
      'Multiple Coupon Count': couponCount,
      'Total Bet Amount': verifyData?.cost,
      'Horse Count': legs?.flat()?.filter(sh => sh)?.map(h => h).length,
      'Race Number Count': selectedInfos?.legsData?.length,
      'Event First Start Time': `${selectedHippodrome?.raceDate}T${selectedHippodrome?.startTime}:00Z`,
      Rebet: isLoadedFromCouponConfig?.rebet ? isLoadedFromCouponConfig?.rebet : false,
      'Rebet Type': isLoadedFromCouponConfig?.rebetType ? isLoadedFromCouponConfig?.rebetType : '-',
      'Saved Coupon': isLoadedFromCouponConfig?.savedCoupon ? isLoadedFromCouponConfig?.savedCoupon : false,
      'Variation Switch Button Status': allVariation,
      'Bet Detail': betDetail.filter(b => b),
      'Writer Flag': fromAuthorData?.isFromAuthor || false,
      'Writer Name': fromAuthorData?.name || '-',
      'Writer Selection Coupon': fromAuthorData?.couponType || '-',
      'Game Type': isFixedOdd ? 'Sabit İhtimalli' : 'Müşterek',
      'System Bet': systemSelected
      // 'User Horse Racing Bet Count': 'incremental', // user.set
      // 'User Horse Racing Bet Amount': incremental, // user.set
      // 'User Horse Racing Pre Bet Amount': incremental, // user.set
      // 'Last Place Horse Racing Bet Time': date //  user.set
    };
    mixpanel.track('TJK Complete Place Bet', mixpanelEvents);
    if (isAuthenticated) {
      mixpanel.people.increment('User Horse Racing Bet Amount', verifyData?.cost);
      mixpanel.people.increment('User Horse Racing Pre Bet Amount', verifyData?.cost);
      mixpanel.people.increment('User Horse Racing Bet Count');
    }
    dispatch(playTJKCoupon());

  };
  const onClearClick = () => {
    if (legs?.length > 0 || combinedHorses?.length > 0) {
      dispatch(openModal('tjkCouponInformationModal', {
        successCallback: () => {
        },
        text: 'Kuponundaki seçimleri silmek istediğine emin misin?'
      }));
    }
  };
  const onSaveClick = () => {
    if (legs.length > 0) {
      if (isAuthenticated) {
        mixpanel.track('Save Coupon', {
          Hippodrome: selectedHippodrome?.city,
          'Bet Type': selectedBet?.description,
          'Bet Amount': state?.multiplier,
          'Total Bet Amount': verifyData?.cost
        });
        dispatch(saveTjkCoupon());
      } else {
        History.push('/giris-yap');
      }
    }
  };
  const onDelete = h => {
    const { horse, hippodrome, bet, leg } = h;
    dispatch(setBetslipToast({
      show: true,
      content: h?.horse?.uniqId ? `<p>Kuponundaki <span>${horse?.horseNo}.${horse?.name} - ${hippodrome?.name?.length > 14 ? hippodrome.name.substring(0, 14) + '...' : hippodrome?.name}</span> bahsi silindi</p>` : `<p>Kuponundaki <span>${h?.horse?.propositionInfo.horseNumbers}.${h?.horse?.propositionInfo?.horseNames} - ${hippodrome?.name?.length > 14 ? hippodrome.name.substring(0, 14) + '...' : hippodrome?.name}</span> bahsi silindi</p>`,
      buttonText: 'Geri Al',
      icon: null,
      onButtonClick: () => {
        dispatch(addHorseToCombinedBetSlip(horse, hippodrome, bet, leg));
        dispatch(resetBetSlipToast());
      }
    }));
    dispatch(removeHorseFromCombinedBetSlip(horse));

  };

  const onSystemClick = () => {
    dispatch(toggleSystemModal(true));
    if (systemAllowed) {
      mixpanel.track('TJK Click System Field on Betslip', {
        BetCount: combinedHorses?.length || 0,
        CurrentSystemValue: system?.join('-')
      });
    } else {
      mixpanel.track('TJK View Exceed Bet Count Info', {
        BetCount: combinedHorses?.length || 0,
        Source: 'System Field'
      });
    }
  };

  useEffect(() => {
    if (availableBets) setSelectedBet(availableBets?.data.find(a => a.id === availableBets.selectedBetTypeId));
  }, [availableBets]);

  useEffect(() => {
    if (hippodromeBetDetails) {
      const max = hippodromeBetDetails?.data?.legs?.map(item => item?.horseDetail?.length).reduce((a, b) => Math.max(a, b));
      setMaxLegCount(max);
    }
  }, [hippodromeBetDetails]);

  useEffect(() => {
    if (maxLegCount > 0) {
      setCells(slipCells(maxLegCount));
    }
  }, [maxLegCount]);

  useEffect(() => {
    let isLocaleValid = false;
    if (!isFixedOdd) {
      isLocaleValid = isBetslipValid(selectedInfos?.selectedBet, legs);
    } else {
      isLocaleValid = combinedHorses?.length > 0;
    }
    if (isLocaleValid && (isMobil ? !isOpen : true)) {
      dispatch(verifyTJKCoupon());
    }
    setIslocaleValid(isLocaleValid);
  }, [selectedInfos?.selectedBet, legs, couponCount, multiplier, allVariation, combinedHorses, programType, isMobil, isOpen, fixedOddMultiplier]);

  useEffect(() => {
    setArrowAnimating(true);
    setTimeout(() => setArrowAnimating(false), 2000);
    if (isBetSlipEmpty(legs) && !isMobil && combinedHorses?.length === 0) {
      dispatch(resetHRBetSlip());
    }
  }, [legs, combinedHorses]);

  useEffect(() => {
    setCost(decimalFormatterLast((state.couponCount || 1) * (verifyData?.cost || verifyErrorData?.cost || 0)) + ' TL');
  }, [state.couponCount, verifyData?.cost, verifyErrorData?.cost]);

  useEffect(() => {
    if (selectedBet?.boxType === BOX_TYPES.HORSE) {
      setLegNumbers(Array.from({ length: selectedBet?.legSize }, (_, index) => index + 1));
    } else if (location?.search.includes('rt')) {
      setLegNumbers(location?.search?.split('&')?.find(item => item.includes('rt'))?.split('=')[1]?.split('-'));
    }
  }, [location, selectedBet?.legSize, selectedBet?.boxTitle]);

  useEffect(() => {
    if (couponCount !== state.couponCount) {
      setState(prev => ({
        ...prev,
        couponCount: couponCount,
      }));
    }

  }, [couponCount]);


  useEffect(() => {
    if (selectedBet?.id) {
      const betId = selectedBet?.id;
      setIsBetWithComma([50, 53, 56, 63].includes(betId));
    }

  }, [selectedBet?.id]);

  useEffect(() => {
    if (verify?.error?.code && [1018, 1025].includes(verify?.error?.code)) {

      toast(
        <ToastTemplate type="success">
          { EnvironmentManager.getMessageText({ key: verify?.error?.domain + verify?.error?.code }).replace('%@', decimalFormatterLast(verify?.error?.extras?.maxCouponCost || 0)) }
        </ToastTemplate>,
        {
          toastId: 'maxCountInfoToast',
          position: 'top-center'
        }
      );
    }

  }, [verify?.error?.extras?.maxCouponCost]);

  useEffect(() => {
    if (programType === PROGRAM_TYPES.FIXED && combinedHorses?.length === 0 && multiplier === 1) {
      const reset = Number(EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.minimum_multiplier' }) || 20);
      dispatch(setHRBetslipMultiplier(reset));
    }
  }, [programType]);

  useEffect(() => {
    setState(prev => ({
      ...prev,
      multiplier: isFixedOdd ? fixedOddMultiplier : multiplier
    }));
  }, [isFixedOdd, multiplier, fixedOddMultiplier]);

  return isMobil ? <MobileBetSlip
    legsCounts={ hippodromeBetDetails?.data?.legs?.map(item => item?.horseDetail?.filter(horse => horse.isRunning === true)?.length) || [] }
    isAnimating={ arrowAnimating }
    onBlur={ onBlur }
    onChange={ onChange }
    onFocus={ onFocus }
    selectedLegs={ legs || [] }
    legNumbers={ legNumbers }
    couponCount={ state?.couponCount }
    cost={ cost }
    multiplier={ state.multiplier }
    buttonDisabled={ !isLocaleValid || verify?.error || play?.isLoading || pageLoading }
    onButtonClick={ onPlayClick }
    onClearClick={ onClearClick }
    onSaveClick={ onSaveClick }
    isBetWithComma={ isBetWithComma }
    betType={ selectedBet?.boxType }
    verify={ verify }
    saveClearButtonDisabled={ legs?.length === 0 }/>
    : <>
      <div id="desktop-betslip" className="newBetSlip">
        <div className="newBetSlip__header">
          <div className="newBetSlip__header-texts">
            <h1>{ !isFixedOdd ? selectedBet?.description : 'Sabit İhtimalli' }</h1>
            { !isFixedOdd && <p>{ selectedHippodrome?.name }</p> }
          </div>
          <div className="newBetSlip__header-icons">
            <div onClick={ onClearClick }
              className={ (!isFixedOdd ? legs?.length === 0 : !(combinedHorses?.length > 0)) ? 'disabled' : '' }>
              <Icon iconName='svgTrashWhite'/>
            </div>
            {
              (((isFixedOdd && EnvironmentManager.getMessageText({ key: 'tjkapp_v1.bulletin_fixodd.couponSaveAvailable' }) === 'true')) || !isFixedOdd)
              && <div onClick={ !(!isLocaleValid || verify?.error || play?.isLoading || pageLoading) && onSaveClick }
                className={ (!isLocaleValid || verify?.error || play?.isLoading || pageLoading) && 'disabled' }>
                <Icon iconName="svgSave"/>
              </div>
            }
          </div>

        </div>
        { isFixedOdd && combinedHorses?.length > 0 && <div className="newBetSlip__horseCount">
          <div className="horseCountText">
            <span>{ combinedHorses?.length } Bahis</span> Ekledin
          </div>
          <div className="horseCount">
            <span>{ combinedHorses?.length } </span>/{ maxHorseCount }
          </div>
        </div> }
        <div className={ `newBetSlip__runs ${isBetWithComma ? 'withComma' : ''}` }>
          { /* eslint-disable-next-line no-nested-ternary */ }
          { isFixedOdd ? <div className="newBetSlip_fixed">
            {
              combinedHorses?.length === 0 ? <div className="newBetSlip_fixed-epmty">
                <Icon iconName="svgNoCoupon"/>
                <div className="texts">
                  <h1>Kuponun boş.</h1>
                  <p>Kuponunda hiç bahis <br/> bulunmuyor.</p>
                </div>

              </div> : <>
                { combinedHorses?.map(h => (
                  <div key={ h?.horse?.uniqId } className="newBetSlip_fixed-item">
                    { h?.horse?.uniqId ? (
                      <h1>{ h?.horse?.horseNo }. { h?.horse?.name }</h1>
                    ) : (
                      h?.horse?.propositionInfo?.horseNumbers?.split('-')
                        ?.sort((a, b) => h?.bet?.isOrdered ? 0 : a - b)
                        ?.map((horseNo, index) => (
                          <h1 key={ horseNo }>
                            <span>{ h?.bet?.isOrdered ? `${index + 1}. At` : 'İlk 2\'ye Girecek At' }</span> { horseNo }. { h?.horse?.propositionInfo?.horseNames?.split('-')[index].trim() }
                          </h1>
                        ))
                    ) }

                    <p>{ h?.leg?.startTime } - { h?.hippodrome?.name } - { h?.leg?.legNo }. Koşu</p>
                    <span>{ h?.bet?.description }</span>

                    <div className="bottom">
                      <div className="fixOdd">{ oddFormatter(h?.horse?.propositionInfo) }</div>
                      <div onClick={ () => onDelete(h) } className="deleteButton">
                        <Icon iconName="svgTrashDarkGrey"/>
                      </div>
                    </div>
                  </div>
                )) }
              </>
            }
          </div> : isBetWithComma
            ? <OrderList legs={ legs } selectedLegNo={ selectedLegNo } onItemRemove={ addLegToBetslip }/>
            : cells?.map(row => <>
                {
                  row?.map(cell => <Cell
                    key={ cell.rowNo.toString() + cell.colNo.toString() }
                    { ...cell }
                    legCount={ selectedBet?.legSize }
                    data={ getData(cell.colNo, cell.rowNo) }
                    selectedData={ legs }
                    isAllSelected={ isAllSelected(cell.colNo, cell.rowNo) }
                    onCellClick={ onCellClick }
                    runwayType={ getRunwayType(cell.colNo) }
                    legNo={ getLegNo(cell.colNo) }/>)
                }
              </>
            ) }
          { pageLoading
            && <div className="newBetSlip__runs-empty"><LottieLoader type="loading" loop={ true } autoplay width="30px"/>
            </div> }
        </div>
        {

          (isFixedOdd ? combinedHorses?.length > 0 : true)
          && <div className={ classnames({
            newBetSlip__footer: true,
          }) }>
            <div className="newBetSlip__footer-top">
              { !isFixedOdd
                && <SelectedLegsList isBetWithComma={ isBetWithComma } selectedLegs={ legs || [] } legNumbers={ legNumbers }
                  legsCounts={ hippodromeBetDetails?.data?.legs?.map(item => item?.horseDetail?.filter(horse => horse.isRunning === true)?.length) || [] }
                  betType={ selectedBet?.boxType }/> }
              <ErrorMessage selectedBetId={ selectedBet?.id } isValid={ isLocaleValid } verifyData={ verify }/>
            </div>
            <div className="newBetSlip__footer-inputs">
              <div className="input-row">
                <div className="input">
                  <span>Misli</span>
                  <input id="multiplier" maxLength={ 5 } type="text" inputMode="numeric" value={ state.multiplier }
                    onChange={ onChange }
                    onBlur={ onBlur } onFocus={ onFocus }/>
                </div>
              </div>
              { (EnvironmentManager.getMessageText({ key: 'v1.system.visible' }) === 'true' && isFixedOdd)
                && <div className="input-row">
                  <div onClick={ onSystemClick } className={ classnames({
                    input: true,
                    disabled: !systemAllowed,
                  }) }>
                    <span>Sistem</span>
                    <div>{ system?.join('-') }</div>
                  </div>
                </div> }
              <div className="input-row">
                <div className="input">
                  <span>Adet</span>
                  <input type="text" inputMode="numeric" maxLength={ 5 } id="couponCount" value={ state.couponCount }
                    onChange={ onChange }
                    onBlur={ onBlur } onFocus={ onFocus }/>
                </div>
              </div>
            </div>
            {
              selectedBet?.isCombinationActive && <div className="newBetSlip__footer-allCheck">
                <span>Komple</span>
                <Checkbox
                  className="switch"
                  checked={ allVariation }
                  onChange={ () => {
                    dispatch(setHRBetslipAllVariation(!allVariation));
                  } }
                />
              </div>
            }
            {
              isLocaleValid &&  <div className="newBetSlip__footer-amount">
                <span>Kupon Tutarı:</span>
                <span>{ cost }</span>
              </div>
            }

            {
              isFixedOdd && <>
                <div className="newBetSlip__footer-amount">
                  <span>Toplam Oran:</span>
                  <span>{ combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah === true) ? 'K.O' : (oddFormatter(verifyData?.fixedOddVerifyResponse?.totalOdd || verifyErrorData?.fixedOddVerifyResponse?.totalOdd)) || '-' }</span>

                </div>
                {
                  (combinedHorses?.length > 0 && !combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah === true))
                  && <div className="newBetSlip__footer-amount">
                    <span>Maks. Kazanç:</span>
                    <span>{ decimalFormatterLast(verifyData?.fixedOddVerifyResponse?.expectedWinAmount || verifyErrorData?.fixedOddVerifyResponse?.expectedWinAmount) || '0' } TL</span>
                  </div>
                }
                {
                  isFixedOdd && <Predicta/>
                }
                {
                  isFixedOdd && combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah === true)
                  && <div className="newBetSlip__extraText">
                    { EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.sp_info' }) }
                  </div>
                }

              </>
            }

            <button onClick={ onPlayClick } disabled={ !isLocaleValid || verify?.error || play?.isLoading || pageLoading }
              className="newBetSlip__footer-button">
              Hemen Oyna
            </button>
          </div>
        }
        {
          isFixedOdd && infos.map((info, index) => <div key={ index }
            className="newBetSlip__info">
            <div onClick={ () => setInfo(info) } className="sp-info-button">
              <Icon iconName="svgQuestionGreen"/>
              { info?.title }
            </div>
          </div>)
        }
      </div>
      <InfoPopup show={ info } title={ info?.title }
        content={ info?.description }
        buttonText="Tamam"
        onButtonClick={ () => setInfo(null) } onClose={ () => setInfo(null) }/>
    </>;
};

NewBetSlip.propTypes = {
  mixpanel: PropTypes.object
};
export default withMixpanel(NewBetSlip);
